import React from 'react';
import styles from './WorkspacePicker.module.scss';
import { useWorkspaceContext } from '@support/hooks/use-workspace-context';
import { FallbackWorkspaceAvatar } from '@views/Onboarding/panels/WorkspacePanel/WorkspaceAvatar';
import { useDispatch } from 'react-redux';
import { navigateToSettings } from '@actions/ui';

export default function WorkspacePicker() {
  const dispatch = useDispatch();
  const { activeWorkspace } = useWorkspaceContext();

  return (
    <div
      className={styles.activeWorkspace}
      onClick={() => dispatch(navigateToSettings({ panel: 'workspace-general' }))}
    >
      <div className={styles.avatarContainer}>
        <FallbackWorkspaceAvatar name={activeWorkspace?.name || ''} />
        <div
          className={styles.avatar}
          style={{ backgroundImage: `url(${activeWorkspace?.avatarURL})` }}
        />
      </div>
      <div className={styles.name}>{activeWorkspace?.name}</div>
    </div>
  );
}
